module.exports = __webpack_public_path__ + "aq.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/aq.svg
// module id = 675
// module chunks = 0